export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="16"
    width="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 .5A7.5 7.5 0 1015.5 8 7.508 7.508 0 008 .5zm2.716 9.4a.577.577 0 01-.816.816L8 8.816l-1.9 1.9a.577.577 0 01-.816-.816l1.9-1.9-1.9-1.9a.577.577 0 11.816-.816l1.9 1.9 1.9-1.9a.578.578 0 01.816.816L8.816 8l1.9 1.9z"
      fill="#021B3D"
      fillOpacity=".36"
    />
  </svg>
);
